import React from 'react';

function Icon({ children, title, className = '' }) {
  return (
    <span className={`ui-icon ${className}`} aria-hidden={title ? undefined : true} title={title}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {children}
      </svg>
    </span>
  );
}

export const MenuIcon = (props) => (
  <Icon {...props}>
    <path d="M4 6h16" />
    <path d="M4 12h16" />
    <path d="M4 18h16" />
  </Icon>
);

export const CloseIcon = (props) => (
  <Icon {...props}>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </Icon>
);

export const DashboardIcon = (props) => (
  <Icon {...props}>
    <rect x="4" y="4" width="6" height="6" rx="1.5" />
    <rect x="14" y="4" width="6" height="6" rx="1.5" />
    <rect x="4" y="14" width="6" height="6" rx="1.5" />
    <rect x="14" y="14" width="6" height="6" rx="1.5" />
  </Icon>
);

export const CalendarIcon = (props) => (
  <Icon {...props}>
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M8 3.5v3" />
    <path d="M16 3.5v3" />
    <path d="M3.5 9h17" />
  </Icon>
);

export const PassIcon = (props) => (
  <Icon {...props}>
    <rect x="4" y="5" width="16" height="14" rx="3" />
    <path d="M8 12h8" />
    <path d="M8 9h5" />
  </Icon>
);

export const GateIcon = (props) => (
  <Icon {...props}>
    <path d="M7 4h10v16H7z" />
    <path d="M12 4v16" />
    <path d="M4 20h16" />
    <path d="M9 11h1" />
    <path d="M14 11h1" />
  </Icon>
);

export const MicrosoftIcon = (props) => (
  <Icon {...props}>
    <rect x="4" y="4" width="7" height="7" fill="currentColor" stroke="none" />
    <rect x="13" y="4" width="7" height="7" fill="currentColor" stroke="none" />
    <rect x="4" y="13" width="7" height="7" fill="currentColor" stroke="none" />
    <rect x="13" y="13" width="7" height="7" fill="currentColor" stroke="none" />
  </Icon>
);

export const ShieldIcon = (props) => (
  <Icon {...props}>
    <path d="M12 3l7 3v5c0 5-3.1 8.7-7 10-3.9-1.3-7-5-7-10V6l7-3z" />
    <path d="M9 12l2 2 4-4" />
  </Icon>
);

export const SearchIcon = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M16 16l4 4" />
  </Icon>
);

export const PlusIcon = (props) => (
  <Icon {...props}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </Icon>
);

export const EditIcon = (props) => (
  <Icon {...props}>
    <path d="M4 20h4l11-11a2.1 2.1 0 0 0-4-4L4 16v4" />
    <path d="M13.5 6.5l4 4" />
  </Icon>
);

export const MapPinIcon = (props) => (
  <Icon {...props}>
    <path d="M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
    <path d="M12 21s7-4.89 7-11a7 7 0 1 0-14 0c0 6.11 7 11 7 11z" />
  </Icon>
);

export const TrashIcon = (props) => (
  <Icon {...props}>
    <path d="M4 7h16" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M6 7l1 13h10l1-13" />
    <path d="M9 7V4h6v3" />
  </Icon>
);
